import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';

type RouteCapability =
  | 'hasInternalAccess'
  | 'hasRemoteDataCollectionAccess'
  | 'hasPogRulesReadAccess'
  | 'hasModEligibilityAccess'
  | 'hasIamGroupsReadAccess';

// A turned-away user goes to `/`, the capability-aware landing, so where each kind of user
// lands is decided in one place.
export const ProtectedRoute: React.FC<{
  element: React.ReactElement;
  capability?: RouteCapability;
}> = ({ element, capability = 'hasInternalAccess' }) => {
  const auth = useAuthContext();

  if (!auth[capability]) {
    return <Navigate to="/" replace />;
  }

  return element;
};
